import {DownloadManager} from "../../../types/downloadManager";

const electron = window.require("electron");
let downloadManager: DownloadManager | any = null;

export default function getDownloadManager(): DownloadManager {
    if (null === downloadManager) {
        downloadManager = electron
            && electron.remote
            && electron.remote.getGlobal('ElectronDownloadManager');
    }

    return downloadManager;
}